import React from 'react';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import AmendmentDataTable, { IAmendmentDataTableProps } from './components/amendment-data-table';
import { useAmendmentListController } from './context/amendment-list-controller';
import { useAmendmentListState } from './context/amendment-list-context';
import PageHeader from '../../../components/page-header';

export function AmendmentListComponent() {
    const {
        navigateToCreate
    } = useAmendmentListController();

    const {
        parameters,
        contractId,
        processNumber
    } = useAmendmentListState();

    const dataTableProperties: IAmendmentDataTableProps = {
        parameters: parameters,
        contractId: contractId
    };

    const contractLabel = processNumber ? `Contrato ${processNumber}` : `Contrato ${contractId}`;

    return (
        <React.Fragment>
            <Grid item xs={12} md={12} lg={12}>
                <PageHeader
                    title={`Aditivos do ${contractLabel}`}
                    subtitle="Gerencie todos os aditivos contratuais vinculados a este contrato"
                    breadcrumbs={[
                        { label: 'Contratos', href: '/contratos' },
                        { label: `Aditivos do ${contractLabel}` }
                    ]}
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        height: "500px",
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <AmendmentDataTable props={dataTableProperties} />
                    <SpeedDial
                        ariaLabel="SpeedDial basic example"
                        sx={{ position: 'absolute', bottom: 16, right: 16 }}
                        onClick={navigateToCreate}
                        icon={<SpeedDialIcon />}
                    />
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
